module.exports = __webpack_public_path__ + "static/media/quiz-hint-2-es-1080p.0f86e89f.mp4";